import styles from './SetNewPass.module.scss';
import { SET_NEW_PASSWORD_REQUIREMENTS } from 'consts';

export const PasswordRequirements = () => {
  return (
    <ul className={styles.list}>
      {SET_NEW_PASSWORD_REQUIREMENTS.map((item, index) => (
        <li key={index} className={styles.listElement}><span>{item}</span></li>
      ))}
    </ul>
  );
};
